import { gql } from '@apollo/client';

export const GET_ATHLETE_DASHBOARD = gql`
  query GetAthleteDashboard {
    getAthleteDashboard {
      athlete {
        _id
        firstName
        lastName
        sports
        team
        profilePicture
        unlockedGameIQLevels {
          sport
          levels
        }
        coaches {
          _id
          firstName
          lastName
          profilePicture
        }
      }
      assessments {
        _id
        type
        sport
        level
        passed
        scorePercent
        dateTaken
        gScore
        etsTraitScores {
          focus
          resilience
          discipline
          coachability
          competitiveness
        }
        profile
        confidence
        blend
      }
    }
  }
`;